import { ChevronDown } from 'lucide-react';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Subtitle = styled.p`
  font-size: 13px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
  margin: 0 0 12px 0;
`;

const AccordionItem = styled.div`
  border-radius: 8px;
  overflow: hidden;
`;

const QuestionButton = styled.button<{ $isOpen: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 0;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
  font-size: 13px;
  font-weight: 300;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f3f4f6' : '#111827')};

  &:hover {
    text-decoration: underline;
  }

  svg {
    flex-shrink: 0;
    transition: transform 0.2s;
    transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0)')};
    color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
  }
`;

const Answer = styled.div<{ $isOpen: boolean }>`
  max-height: ${({ $isOpen }) => ($isOpen ? '300px' : '0')};
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  overflow: hidden;
  transition: max-height 0.25s ease, opacity 0.2s ease;
`;

const AnswerInner = styled.div`
  padding: 0 0 14px;
  font-size: 13px;
  line-height: 1.6;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#d1d5db' : '#4b5563')};
`;

const TIPS_COUNT = 10;

export const HelpDrawerContent: FC = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  const items = Array.from({ length: TIPS_COUNT }, (_, i) => ({
    question: t(`helpDrawer.tips.q${i + 1}`),
    answer: t(`helpDrawer.tips.a${i + 1}`),
  }));

  return (
    <Wrapper>
      <Subtitle>{t('helpDrawer.subtitle')}</Subtitle>
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          // eslint-disable-next-line react/no-array-index-key
          <AccordionItem key={index}>
            <QuestionButton $isOpen={isOpen} onClick={() => toggle(index)}>
              {item.question}
              <ChevronDown size={16} />
            </QuestionButton>
            <Answer $isOpen={isOpen}>
              <AnswerInner>{item.answer}</AnswerInner>
            </Answer>
          </AccordionItem>
        );
      })}
    </Wrapper>
  );
};
